import { useState } from "react";
import LoadingScreen from "../components/LoadingScreen";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Categories from "../components/Categories";
import ProductGrid from "../components/ProductGrid";
import About from "../components/About";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import CartSheet from "../components/CartSheet";

export default function ShopPage() {
  const [loaded, setLoaded] = useState(false);
  const [activeCategory, setActiveCategory] = useState(null);

  const onPickCategory = (key) => {
    setActiveCategory(key);
    setTimeout(() => {
      const el = document.getElementById("products");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 50);
  };

  return (
    <div data-testid="shop-page">
      {!loaded && <LoadingScreen onDone={() => setLoaded(true)} />}
      <Navbar />
      <main>
        <Hero />
        <Categories onPick={onPickCategory} />
        <ProductGrid activeCategory={activeCategory} onCategoryClear={() => setActiveCategory(null)} />
        <About />
        <Contact />
      </main>
      <Footer />
      <CartSheet />
    </div>
  );
}
